import React from 'react';
import { useParams } from 'react-router-dom';
import EntityUsersPage from '@features/user/pages/EntityUsersPage';

const ChurchUsersPage: React.FC = () => {
  const { churchId } = useParams<{ churchId: string }>();
  return (
    <EntityUsersPage
      scope="CHURCH"
      scopeRefId={Number(churchId)}
      title="Users"
      subtitle="People with roles at this church"
      testId="church-users-search"
    />
  );
};

export default ChurchUsersPage;
